import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

import { SettingsScreen } from '@/features/identity';
import { Omnibox } from '@/features/search';

import { useLastAppRoute } from './lastAppRoute';
import styles from './SettingsShell.module.css';
import { UserMenu } from './UserMenu';

/**
 * Ustawienia jako **osobny widok pełnoekranowy**, nie ekran w środku aplikacji.
 *
 * ⚠ Wcześniej `/settings` było trasą-dzieckiem `AppShell`, więc ustawienia rysowały się
 * w treści, obok menu z listami roboczymi. Zmiana jest w intencji, nie w układzie:
 * **wejście w ustawienia to wyjście z pracy**. Menu główne znika, zostaje spis sekcji
 * (`SettingsScreen`) i droga powrotna — czyli ten sam wzorzec, którego ludzie nauczyli się
 * w GitHubie i Linearze.
 *
 * ⭐ **Ctrl+K żyje także tutaj, ale bez widocznego paska.** Spec sek. 5 mówi „jedno pole,
 * skrót na każdej stronie", a jednocześnie pasek z pigułkami byłby zaproszeniem do szukania
 * elementów w miejscu, w którym się ich nie ogląda. Rozwiązanie: `Omnibox` jest zamontowany
 * (to on trzyma globalny skrót), wyzwalacza nie ma. Odruch działa wszędzie, także tam, gdzie
 * człowiek jest „nie u siebie".
 */
export function SettingsShell() {
  const { t } = useTranslation();
  const back = useLastAppRoute((state) => state.path);

  return (
    <div className={styles['screen']}>
      <div className={styles['top']}>
        <Link className={styles['back']} to={back}>
          <ArrowLeft size={16} aria-hidden="true" />
          {t('app.settings.back')}
        </Link>

        <span className={styles['title']}>{t('app.settings.title')}</span>

        <span className={styles['spacer']} />
        <UserMenu />
      </div>

      <SettingsScreen />

      <Omnibox />
    </div>
  );
}
